import { styled } from '@linaria/react';

import { Tooltip } from '~/shared/ui/Tooltip/Tooltip';

import InfoIcon from './images/info-icon.svg';

export const Root = styled.dt`
  display: inline-block;
  margin: 0;
  padding: 0;
  color: #b2b2b2;
`;

export const TooltipContainer = styled.span`
  vertical-align: middle;
  white-space: nowrap;
`;

export const StyledTooltip = styled(Tooltip)`
  display: inline-block;
  margin-left: 4px;
  white-space: normal;
`;

export const StyledInfoIcon = styled(InfoIcon)`
  display: block;
  width: 16px;
  aspect-ratio: 1;
  flex-grow: 0;
  flex-shrink: 0;
`;
